// extracted by mini-css-extract-plugin
export default {"newh3":"HintModal_newh3__s25nc","row":"HintModal_row__E822X","showhintbut":"HintModal_showhintbut__ZoAlz","shownhintbut":"HintModal_shownhintbut__0XTiQ"};